import { IntlShape } from 'react-intl';

enum JobTitles {
    JOB_MANAGING_DIRECTOR = 'managing_director',
    JOB_FINANCE = 'finance',
    JOB_PURCHASER = 'purchaser',
    JOB_SALES = 'sales',
    JOB_INSTALLER = 'installer',
    JOB_OTHER = 'other',
}

export const JOB_TITLES = (intl?: IntlShape) => [
    {
        label: intl
            ? intl.formatMessage({ id: 'common.jobTitle.managingDirector', defaultMessage: 'Managing Director' })
            : 'Managing Director',
        value: JobTitles.JOB_MANAGING_DIRECTOR,
    },
    {
        label: intl ? intl.formatMessage({ id: 'common.jobTitle.finance', defaultMessage: 'Finance' }) : 'Finance',
        value: JobTitles.JOB_FINANCE,
    },
    {
        label: intl
            ? intl.formatMessage({ id: 'common.jobTitle.purchaser', defaultMessage: 'Purchaser' })
            : 'Purchaser',
        value: JobTitles.JOB_PURCHASER,
    },
    {
        label: intl ? intl.formatMessage({ id: 'common.jobTitle.sales', defaultMessage: 'Sales' }) : 'Sales',
        value: JobTitles.JOB_SALES,
    },
    {
        label: intl
            ? intl.formatMessage({ id: 'common.jobTitle.installer', defaultMessage: 'Installer' })
            : 'Installer',
        value: JobTitles.JOB_INSTALLER,
    },
    {
        label: intl ? intl.formatMessage({ id: 'common.jobTitle.other', defaultMessage: 'Other' }) : 'Other',
        value: JobTitles.JOB_OTHER,
    },
];
